import React, { useState, useEffect } from "react";
import { getFiles, getOnedrive, createOnedrive } from "../api/api";
import { tab } from "@testing-library/user-event/dist/tab";

const Filemanager = () => {
  const [okmessage, setOKmessage] = useState("");
  const [files, setFiles] = useState([]);
  const [path, setPath] = useState("Reboot");

  const loadFiles = async (file) => {

    // const response = await getFiles(file);
    // setOKmessage(response.status === 200 ? "Files loaded successfully" : "Error loading files");
    // setFiles(response.data.files);
    // setPath(response.data.path);
    // console.log(path + files);

    const newPath = path + (file ? `%2F${file}` : "");
    setPath(newPath);
    console.log(newPath);
    const onedriveResponse = await getOnedrive("DIX", newPath);
    setFiles(onedriveResponse.data);
    console.log("Onedrive response data:", onedriveResponse.data);
  };

  useEffect(() => {
    loadFiles();
    console.log(path + files);
  }, []);

  return (
    <div className="card">
      <div className="card-header">
        <h5>List of files</h5>
      </div>
      <div className="card-body">
        {files && files.map((file, index) => {
          const fileName = file.split('/').pop();
          const fileExtension = fileName.split('.')[1];
          // const fileURL = `${path}${file}`;
          const fileURL = file;
          console.log('extension:', fileExtension, 'URL:', fileURL);
          switch (fileExtension) {
            case 'jpg':
            case 'jpeg':
            case 'png':
            case 'bmp':
            case 'gif':
              return (
                <a key={index} href={`${fileURL}`} target="_blank" rel="noopener noreferrer">
                  <button type="button" className="btn btn-icon" title={file}>
                    <span className="material-symbols-outlined">image</span>
                  </button>
                </a>
              );
            case 'txt':
            case 'doc':
            case 'docx':
              return (
                <a key={index} href={`${fileURL}`} target="_blank" rel="noopener noreferrer">
                  <button type="button" className="btn btn-icon" title={file}>
                    <span className="material-symbols-outlined">article</span>
                  </button>
                </a>
              );
            case 'pdf':
              return (
                <a key={index} href={`${fileURL}`} target="_blank" rel="noopener noreferrer">
                  <button type="button" className="btn btn-icon" title={file}>
                    <span className="material-symbols-outlined">picture_as_pdf</span>
                  </button>
                </a>
              );
            case 'zip':
            case 'rar':
              return (
                <a key={index} href={`${fileURL}`} target="_blank" rel="noopener noreferrer">
                  <button type="button" className="btn btn-icon" title={file}>
                    <span className="material-symbols-outlined">folder_zip</span>
                  </button>
                </a>
              );
            case 'mkv':
            case 'mkv':
            case 'mp4':
            case 'avi':
            case 'mov':
                    return (
                    <button type="button" className="btn btn-icon" title={file}
                      onClick={() => {
                      const videoWindow = window.open("", "_blank");
                      videoWindow.document.write(`
                        <!DOCTYPE html>
                        <html>
                        <head>
                          <title>${fileName}</title>
                          <style>
                          body { margin: 0; padding: 0; background: #000; }
                          video { width: 100%; height: 100vh; }
                          </style>
                        </head>
                        <body>
                          <video controls autoplay>
                          <source src="${fileURL}" type="video/mp4">
                          Your browser does not support the video tag.
                          </video>
                        </body>
                        </html>
                      `);
                      videoWindow.document.close();
                      }}>
                      <span className="material-symbols-outlined">movie</span>
                    </button>
                    );
            case undefined: // Folder
              return (
                // <a key={index} href={`/filemanager?p=${file}`} rel="noopener noreferrer">
                <button type="button" className="btn btn-icon" title={file}
                  onClick={() => loadFiles(file)}>
                  <span className="material-symbols-outlined">folder</span>
                </button>
                // </a>
              );
            default:
              return (
                <a key={index} href={`${fileURL}`} target="_blank" rel="noopener noreferrer">
                  <button type="button" className="btn btn-icon" title={file}>
                    <span className="material-symbols-outlined">insert_drive_file</span>
                  </button>
                </a>
              );
          }
        })}
        <button type="button" className="btn btn-icon" title={"Add folder"}
          onClick={() => createOnedrive("DIX", path, "New Folder").then(() => loadFiles())}>
          <span className="material-symbols-outlined">add</span>
        </button>
      </div>
    </div>
  );
}
export default Filemanager;